import { goatTestnet } from './goatTestnet';
import { goatMainnet } from './goatMainnet';
import { MainnetOnly } from 'constant';
export const projectId = '68500c9c1e5f2c9a8465c415f19cef29';
import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import {
    argentWallet,
    imTokenWallet,
    ledgerWallet,
    okxWallet,
    oneKeyWallet,
    trustWallet,
    uniswapWallet,
    bitgetWallet,
    metaMaskWallet,
    walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';

export interface MyWalletOptions {
    projectId: string;
}

const wallets = [
    {
        groupName: 'Popular',
        wallets: [metaMaskWallet, okxWallet, walletConnectWallet, bitgetWallet],
    },
    {
        groupName: 'Other',
        wallets: [
            argentWallet,
            trustWallet,
            ledgerWallet,
            okxWallet,
            imTokenWallet,
            uniswapWallet,
            oneKeyWallet,
            bitgetWallet,
        ],
    },
];

const chainConfig = MainnetOnly
    ? {
          chains: [goatMainnet],
          appName: 'GOAT OnePiece Protocol',
          projectId,
          wallets,
      }
    : {
          chains: [goatTestnet],
          appName: 'GOAT OnePiece Protocol',
          projectId,
          wallets,
      };

export default getDefaultConfig(chainConfig as any);
